import {
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogHeader,
    GridRow,
    ToastLevel,
    useIntl,
    useToast,
} from "@metsooutotec/modes-react-components"
import { FC, useEffect, useState } from "react"
import { WSRoles, WSUser } from "features/users/models/users-models"
import usersStore from "features/users/store/users-store"
import { observer } from "mobx-react-lite"

interface UserRolesModalProps {
    isOpen: boolean
    setIsOpen: React.Dispatch<React.SetStateAction<boolean>>
    user: WSUser
}

const UserRolesModal: FC<UserRolesModalProps> = observer(({ isOpen, setIsOpen, user }) => {
    const { formatMessage } = useIntl()
    const { setMessage } = useToast()
    const { userLoading, updateUserRoles } = usersStore
    const [localRoles, setLocalRoles] = useState<WSRoles[]>([])

    useEffect(() => {
        if (isOpen && Array.isArray(user.roles)) {
            setLocalRoles(user.roles.map(role => ({ ...role })))
        }
    }, [isOpen, user.id])

    const toggleRole = (roleId: string) => {
        setLocalRoles(prev => prev.map(role => (role.id === roleId ? { ...role, assigned: !role.assigned } : role)))
    }

    const handleSave = async () => {
        try {
            const result = await updateUserRoles(user.id, localRoles)
            if (!result.passed) {
                setMessage(formatMessage("userResetRoles.fieldMessage"), ToastLevel.ALARM)
                return
            }
            setMessage(formatMessage("userResetRoles.successMessage"), ToastLevel.SUCCESS)
            setIsOpen(false)
        } catch (e) {
            setMessage(formatMessage("userResetRoles.fieldMessage"), ToastLevel.ALARM)
        }
    }

    return (
        <Dialog open={isOpen} onClose={() => setIsOpen(false)} size='tiny'>
            <DialogHeader>{formatMessage("user.roles")}</DialogHeader>
            <DialogContent>
                {localRoles.map(role => (
                    <GridRow key={role.id}>
                        <Checkbox label={role.name} checked={role.assigned} onChange={() => toggleRole(role.id)} />
                    </GridRow>
                ))}
            </DialogContent>
            <DialogActions>
                <Button onClick={() => setIsOpen(false)}>{formatMessage("common.cancel")}</Button>
                <Button onClick={handleSave} loading={userLoading} disabled={userLoading} primary>
                    {formatMessage("common.save")}
                </Button>
            </DialogActions>
        </Dialog>
    )
})

export default UserRolesModal
